exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n.arrow {\n  align-items: center;\n  border-radius: 3px;\n  height: 18px;\n  width: 34px;\n  display: flex;\n  justify-content: center;\n}\n.arrow .pl2 {\n  padding-left: 2px;\n}\n", ""]);

// exports
